import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AscendLandingPage } from "@/components/AscendLandingPage";
import { MathMethodsPage } from "@/components/MathMethodsPage";
import { SpecialistMathsPage } from "@/components/SpecialistMathsPage";
import { AdminDashboard } from "@/components/platform/AdminDashboard";
import { PortalLoginPage } from "@/components/platform/PortalLoginPage";
import { StudentDashboard } from "@/components/platform/StudentDashboard";

function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        window.requestAnimationFrame(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }

      return;
    }

    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<AscendLandingPage />} />
          <Route path="/math-methods" element={<MathMethodsPage />} />
          <Route path="/specialist-maths" element={<SpecialistMathsPage />} />
          <Route path="/platform" element={<PortalLoginPage />} />
          <Route path="/portal/admin" element={<AdminDashboard />} />
          <Route path="/portal/student" element={<StudentDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
